import { connectionMessageKeys, connectionProblem, isApiError, type ApiError } from '@hlt/web-kit/api';
import type { useT } from '@hlt/web-kit/i18n';

type Translate = ReturnType<typeof useT>;

/**
 * How long a sign-in step waits for HLT Cloud before saying it cannot be reached, instead of leaving the
 * button spinning while a server hangs.
 */
export const authTimeoutMs = 20_000;

/**
 * The sentence shown when a sign-in, two-factor, password, invitation or confirmation step fails. Every
 * auth page names connection problems the same way (offline, HLT Cloud unreachable, a failure on HLT's
 * side), `specific` explains the step's own answers (a wrong password or code), and everything else reads
 * as the server-side failure. Server messages are English developer text and are never shown.
 */
export function authErrorMessage(
    error: unknown,
    t: Translate,
    specific: (error: ApiError) => string | null = () => null,
): string {
    const problem = connectionProblem(error);
    if (problem) return t(connectionMessageKeys[problem]);
    if (!isApiError(error)) return t(connectionMessageKeys.server);
    if (error.code === 'rate_limited') return t('errors.rateLimited');
    return specific(error) ?? t(connectionMessageKeys.server);
}
